import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCXetaxitable = React.memo(function BCXetaxitable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p3_sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Lượt xe thực hiện</td>
          <td className={classes.tablebc_td}>lượt</td>
          <td className={classes.tablebc_td}>{data.p3_soluotxethuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Sản lượng khách vận chuyển</td>
          <td className={classes.tablebc_td}>lượt khách</td>
          <td className={classes.tablebc_td}>{data.p3_sokhachvanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Doanh thu</td>
          <td className={classes.tablebc_td}>Tr.đ</td>
          <td className={classes.tablebc_td}>{data.p3_doanhthu}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXetaxitable.propTypes = {
  data: PropTypes.object,
};
export default BCXetaxitable;
